export const RATES_LOGS_GET = 'RATES_LOGS_GET';
export const RATES_SET_AMOUNT = 'RATES_SET_AMOUNT';
export const RATES_SET_HISTORIC = 'RATES_SET_HISTORIC';
